import { Mixins, Component } from 'vue-property-decorator';
import api from '@/api/org';
import { ITABLECOLCONF } from '@/types/base.d';
import pageMixin from '../../../mixins/pageMixin';

@Component
export default class tableMixin extends Mixins(pageMixin) {
  private mList: any = [];

  private column: Array<ITABLECOLCONF> = [{
    label: '名称',
    prop: 'orgTitle',
    align: 'center',
    tooltip: true,
  }, {
    label: '账号',
    align: 'center',
    prop: 'loginName',
  }, {
    label: '状态',
    prop: 'loginStatus',
    custom: true,
    align: 'center',
    tags: [{
      value: '0',
      type: 'warning',
      label: '禁用',
    }, {
      value: '1',
      type: 'success',
      label: '启用',
    }],
  }, {
    label: '邀请码',
    prop: 'invitationCode',
    align: 'center',
  }, {
    label: '创建时间',
    align: 'center',
    custom: true,
    tag: {
      type: 'primary',
      prop: ['createTime'],
    },
  }, {
    label: '操作',
    custom: true,
    minWidth: '120',
    maxBtn: 1,
    btnList: [
      {
        title: '操作',
        name: '/org/manage:operate',
        icon: 'edit',
        type: 'info',
        callback: this.handleOperate,
        log: {
          name: '机构管理 - 操作',
          component: 'org/manage/tableMixin',
        },
      },
      {
        title: '编辑',
        name: '/org/manage:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleUpdateForm,
        log: {
          name: '机构管理 - 编辑',
          component: 'org/manage/tableMixin',
        },
      },
      {
        title: '删除',
        name: '/org/manage:remove',
        icon: 'remove',
        type: 'info',
        callback: this.handleRmove,
        log: {
          name: '机构管理 - 删除',
          component: 'org/manage/tableMixin',
        },
      },
      {
        title: '重置密码',
        name: '/org/manage:reset',
        icon: 'refresh',
        type: 'info',
        callback: this.handleResetPwd,
        log: {
          name: '机构管理 - 重置密码',
          component: 'org/manage/tableMixin',
        },
      },
      {
        title: '生成邀请码',
        name: '/org/manage:generateCode',
        type: 'info',
        callback: this.handleGenerateCode,
        handleDis: (row: any) => !!row.invitationCode,
        log: {
          name: '机构管理 - 生成邀请码',
          component: 'org/manage/tableMixin',
        },
      },
    ],
    align: 'center',
  }];

  private loading: boolean = true;

  mounted() {
    this.getData();
  }

  /* eslint-disable class-methods-use-this */
  /**
   * @author liangyongmou
   * @desc 获取机构列表
   */
  getData(params?: object) {
    this.loading = true;
    this.page.params = params
    const data = { pageSize: this.page.pageSize, pageNo: this.page.pageNo, ...this.page.params }
    api.getOrgList(data).then((res: any) => {
      this.mList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  /**
   * @author liangyongmou
   * @desc 机构操作
   * @param { any } row 行数据
   */
  handleOperate(row: any) {
    this.$router.push({ name: 'org/operate', params: { pid: Base64.encode(row.pid) } });
  }

  /* eslint-disable class-methods-use-this */
  handleUpdateForm(row: any) {}

  /**
   * @author liangyongmou
   * @desc 删除机构操作
   * @param { any } row 行数据
  */
  handleRmove(row: any) {
    this.confirm('此操作将永久删除该数据, 是否继续?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeOrg({ id: row.pid }).then(() => {
        this.getData();
        close();
        this.$log({
          title: '机构管理 - 删除 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '机构管理 - 删除 - 取消',
      component: 'org/manage/tableMixin',
    }));
  }

  /**
   * @author liangyongmou
   * @desc 重置密码操作
   * @param { any } row 行数据
  */
  handleResetPwd(row: any) {
    this.confirm('你确定为该机构重置密码吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.resetOrgPwd({ id: Base64.encode(row.pid) }).then(() => {
        close();
        this.$log({
          title: '机构管理 - 重置密码 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '机构管理 - 重置密码 - 取消',
      component: 'org/manage/tableMixin',
    }));
  }

  /**
   * @author liangyongmou
   * @desc 生成邀请码操作
   * @param { any } row 行数据
  */
  handleGenerateCode(row: any) {
    this.confirm('你确定为该机构生成邀请码吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.generateOrgCode({ id: row.pid }).then(() => {
        this.getData();
        close();
        this.$log({
          title: '机构管理 - 生成邀请码 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '机构管理 - 生成邀请码 - 取消',
      component: 'org/manage/tableMixin',
    }));
  }
}
